import Vue from 'vue'
import Vuex from 'vuex'
import firebase from './firebase'
import router from './router'

Vue.use(Vuex)
Vue.use(firebase)

function fibonacci(num, memo) {
  memo = memo || {};
  if (memo[num]) return memo[num];
  if (num <= 1) return 1;
  return memo[num] = fibonacci(num - 1, memo) + fibonacci(num - 2, memo);
}

function clearUserInfo() {
  localStorage.removeItem('uuid');
  localStorage.removeItem('room');
}

function setUserInfo(uuid, roomNumber) {
  localStorage.setItem('uuid', uuid);
  localStorage.setItem('room', roomNumber);
}

export default new Vuex.Store({
  state: {
    vote: 0,
    users: null,
    uuid: null,
    roomNumber: null,
    forceReveal: false
  },
  mutations: {
    submitName(state, name) {
      const roomNumber = router.currentRoute.params.id;
      const newUser = firebase.database.ref('rooms').child(roomNumber).push();
      const uuid = newUser.key;
      newUser.set({
        'name': name,
        'submittedVote': 0
      }).then(() => {
        state.uuid = uuid;
        state.roomNumber = roomNumber;
        setUserInfo(uuid, roomNumber);
      });
    },
    submitVote(state, vote) {
      const submittedVote = vote ? fibonacci(vote) : 0;
      state.vote = submittedVote;
      firebase.database.ref(`rooms/${localStorage.room}/${localStorage.uuid}`).child("submittedVote").set(submittedVote);
    },
    deleteUser(state, userUuid) {
      if (!userUuid) {
        state.uuid = null;
        state.roomNumber = null;
      }
      firebase.database.ref(`rooms/${localStorage.room}/${userUuid ? userUuid : localStorage.uuid}`).remove().then(() => {
        if (!userUuid) {
          clearUserInfo();
        }
      });
    },
    retrieveUser(state) {
      const uuid = localStorage.uuid;
      firebase.database.ref(`rooms/${localStorage.room}/${uuid}`).once("value").then(() => {
        state.uuid = uuid;
      });
    },
    resetVotes(state) {
      state.forceReveal = false;
      for (let uuid in state.users) {
        firebase.database.ref(`rooms/${localStorage.room}/${uuid}`).child("submittedVote").set(0);
      }
    },
    setUsers(state) {
      const roomNumber = router.currentRoute.params.id;
      firebase.database.ref(`rooms/${roomNumber}`).on("value", (snapshot) => {        
        const users = snapshot.val();
        const uuid = state.uuid;
        state.users = users;
        if(uuid && users) {
          if (!users[uuid]) {
            clearUserInfo();
          }
        }
      });
    },
    setForceReveal(state) {
      state.forceReveal = true;
    },
    verifyUser(state) {
      const roomNumber = router.currentRoute.params.id;
      const localStorageRoom = localStorage.room;
      const localStorageUuid = localStorage.uuid;
      if (localStorageRoom && localStorageUuid) {
        firebase.database.ref(`rooms/${localStorageRoom}/${localStorageUuid}`).once("value").then((snapshot) => {
          const user = snapshot.val();
          if (!user) {
            clearUserInfo();
          } else if (roomNumber !== localStorageRoom) {
            setUserInfo(localStorageUuid, roomNumber);
            firebase.database.ref(`rooms/${roomNumber}/${localStorageUuid}`).set(user).then(() => {
              firebase.database.ref(`rooms/${localStorageRoom}/${localStorageUuid}`).remove();
            });
          }
        });
      }
    }
  },
  actions: {
    setUsers(context) {
      context.commit('setUsers');
    },
    verifyUser(context, roomNumber) {
      context.commit('verifyUser', roomNumber);
    }
  },
  getters: {
    getVote(state) {
      const vote = state.vote;
      return vote ? fibonacci(vote) : "No Vote";
    },
    getSubmittedVote(state) {
      let currentUser = "";
      const uuid = state.uuid;
      if (uuid) {
        currentUser = state.users[uuid];
      }
      return currentUser.submittedVote;
    },
    getOtherUsers(state) {
      let otherUsers = {};
      const allUsers = state.users;
      const uuid = state.uuid;
      if (uuid) {
        if (allUsers) {
          // eslint-disable-next-line
          const { [uuid]: _, ...newData } = allUsers;
          otherUsers = newData;
        }
      }
      return otherUsers;
    },
    getAllUsers(state) {
      return state.users;
    },
    getMyName(state) {
      let currentUser = "";
      const uuid = state.uuid;
      const users = state.users;
      if (uuid && users) {
        currentUser = users[uuid];
      }
      return currentUser ? currentUser.name : "";
    },
    getFib() {
      return keyword => fibonacci(keyword);
    },
    allVoted(state) {
      if (state.forceReveal) {
        return true;
      }
      let flag = true;
      const users = state.users;
      for (let key in users) {
        flag = (users[key].submittedVote > 0) & flag;
      }
      return flag;
    }
  }
})